// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_header__HXQOm {
    background-color: var(--color-bg-header);
    color: var(--color-text);
    padding: 1rem;
    text-align: left;
    font-size: 20px !important;
    bottom: 5px;
  }

  div.Header_header__HXQOm {
    font-size: 20px;
  }

  .Header_header__HXQOm h3 {
    margin-top: 30px; /* Moves the text down */
  }

  @media (max-width: 1024px) {
    .Header_header__HXQOm {
      padding: 0.25rem 0;
      text-align: right;
      font-size: 12px !important;
    }

    .Header_header__HXQOm h3 {
      margin-top: 0;
      line-height: 1.2;
      font-size: 12px;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.module.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,wBAAwB;IACxB,aAAa;IACb,gBAAgB;IAChB,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB,EAAE,wBAAwB;EAC5C;;EAEA;IACE;MACE,kBAAkB;MAClB,iBAAiB;MACjB,0BAA0B;IAC5B;;IAEA;MACE,aAAa;MACb,gBAAgB;MAChB,eAAe;IACjB;EACF","sourcesContent":[".header {\n    background-color: var(--color-bg-header);\n    color: var(--color-text);\n    padding: 1rem;\n    text-align: left;\n    font-size: 20px !important;\n    bottom: 5px;\n  }\n\n  div.header {\n    font-size: 20px;\n  }\n\n  .header h3 {\n    margin-top: 30px; /* Moves the text down */\n  }\n\n  @media (max-width: 1024px) {\n    .header {\n      padding: 0.25rem 0;\n      text-align: right;\n      font-size: 12px !important;\n    }\n\n    .header h3 {\n      margin-top: 0;\n      line-height: 1.2;\n      font-size: 12px;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__HXQOm`
};
export default ___CSS_LOADER_EXPORT___;
